"use strict";
// Application constants
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLORS = exports.BODY_TYPES = exports.TRANSMISSION_TYPES = exports.FUEL_TYPES = exports.REGIONS = exports.CHEVROLET_MODELS = exports.CAR_BRANDS = exports.CONSTANTS = void 0;
exports.CONSTANTS = {
    // Image limits
    MAX_IMAGES: 4,
    MIN_IMAGE_WIDTH: 800,
    MIN_IMAGE_HEIGHT: 600,
    // Collage settings
    COLLAGE_WIDTH: 1200,
    COLLAGE_HEIGHT: 900,
    // File size limits (in bytes)
    MAX_IMAGE_SIZE: 10 * 1024 * 1024, // 10MB
    MAX_AUDIO_SIZE: 20 * 1024 * 1024, // 20MB
    // Timeout settings (in ms)
    IMAGE_PROCESSING_TIMEOUT: 30000,
    AUDIO_PROCESSING_TIMEOUT: 60000,
    // Post expiration (in days)
    POST_EXPIRATION_DAYS: 30,
    // Session timeout (in hours)
    SESSION_TIMEOUT_HOURS: 24,
};
// Car brands commonly sold in Uzbekistan
exports.CAR_BRANDS = [
    { value: 'chevrolet', label: 'Chevrolet' },
    { value: 'daewoo', label: 'Daewoo' },
    { value: 'ravon', label: 'Ravon' },
    { value: 'toyota', label: 'Toyota' },
    { value: 'hyundai', label: 'Hyundai' },
    { value: 'kia', label: 'Kia' },
    { value: 'mercedes', label: 'Mercedes-Benz' },
    { value: 'bmw', label: 'BMW' },
    { value: 'audi', label: 'Audi' },
    { value: 'volkswagen', label: 'Volkswagen' },
    { value: 'lada', label: 'Lada' },
    { value: 'gac', label: 'GAC' },
    { value: 'byd', label: 'BYD' },
    { value: 'haval', label: 'Haval' },
    { value: 'chery', label: 'Chery' },
    { value: 'geely', label: 'Geely' },
    { value: 'other', label: 'Boshqa' },
];
// Chevrolet models (most common)
exports.CHEVROLET_MODELS = [
    'Cobalt',
    'Nexia',
    'Gentra',
    'Lacetti',
    'Spark',
    'Malibu',
    'Tracker',
    'Equinox',
    'Captiva',
    'Orlando',
    'Cruze',
    'Aveo',
    'Epica',
    'Onix',
    'Tahoe',
];
// Regions of Uzbekistan
exports.REGIONS = [
    { value: 'toshkent_sh', label: 'Toshkent shahri' },
    { value: 'toshkent_v', label: 'Toshkent viloyati' },
    { value: 'andijon', label: 'Andijon' },
    { value: 'buxoro', label: 'Buxoro' },
    { value: 'fargona', label: 'Farg\'ona' },
    { value: 'jizzax', label: 'Jizzax' },
    { value: 'xorazm', label: 'Xorazm' },
    { value: 'namangan', label: 'Namangan' },
    { value: 'navoiy', label: 'Navoiy' },
    { value: 'qashqadaryo', label: 'Qashqadaryo' },
    { value: 'samarqand', label: 'Samarqand' },
    { value: 'sirdaryo', label: 'Sirdaryo' },
    { value: 'surxondaryo', label: 'Surxondaryo' },
    { value: 'qoraqalpogiston', label: 'Qoraqalpog\'iston' },
];
// Fuel types
exports.FUEL_TYPES = [
    { value: 'PETROL', label: 'Benzin' },
    { value: 'GAS', label: 'Metan/Propan' },
    { value: 'DIESEL', label: 'Dizel' },
    { value: 'HYBRID', label: 'Gibrid' },
    { value: 'ELECTRIC', label: 'Elektr' },
];
// Transmission types
exports.TRANSMISSION_TYPES = [
    { value: 'MANUAL', label: 'Mexanika' },
    { value: 'AUTOMATIC', label: 'Avtomat' },
];
// Body types
exports.BODY_TYPES = [
    { value: 'SEDAN', label: 'Sedan' },
    { value: 'HATCHBACK', label: 'Xetchbek' },
    { value: 'SUV', label: 'Vnedorojnik' },
    { value: 'CROSSOVER', label: 'Krossover' },
    { value: 'MINIVAN', label: 'Miniven' },
    { value: 'COUPE', label: 'Kupe' },
    { value: 'PICKUP', label: 'Pikap' },
    { value: 'WAGON', label: 'Universal' },
];
// Colors
exports.COLORS = [
    { value: 'white', label: 'Oq' },
    { value: 'black', label: 'Qora' },
    { value: 'silver', label: 'Kumush' },
    { value: 'gray', label: 'Kulrang' },
    { value: 'red', label: 'Qizil' },
    { value: 'blue', label: 'Ko\'k' },
    { value: 'green', label: 'Yashil' },
    { value: 'brown', label: 'Jigarrang' },
    { value: 'beige', label: 'Bej' },
    { value: 'gold', label: 'Oltin' },
    { value: 'other', label: 'Boshqa' },
];
//# sourceMappingURL=constants.js.map